import React from 'react'
import {CircularProgress, Grid} from '@material-ui/core'
import Styled from '../../components/Styled'
import styles from './styles'
import _TextInput from '../../components/TextInput'
import ButtonLarge, {Props as ButtonLargeProps} from 'src/components/Buttons/ButtonLarge'
import H2 from 'src/components/Typography/H2'

export const RootGrid = Styled(Grid, styles.rootGrid)
export const Title = Styled(H2, styles.title)
export const TextInput = _TextInput
export const LoginButton = (props: ButtonLargeProps) => <ButtonLarge {...props} />
export const ActivityIndicator = CircularProgress
